import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CmDropdownComponent } from '../../../shared/components/table/cm-dropdown.component';
import { ReportMetric, ReportMetricDetails } from '../domain/report/report-metric.enum';

@Component({
  selector: 'cm-report-metric-singleselect-dropdown',
  template: `
    <cm-dropdown #dropdown [header]="'Metrics'"
                 (toggleDropdown)="toggle($event)"
                 [tooltip]="'Metrics'">
      <cm-dropdown-trigger>
        <button mat-button color="primary" *ngIf="showLabel">
          <i class="far fa-list-ul"></i>
        </button>
        <button mat-icon-button color="primary" *ngIf="!showLabel">
	        <i class="far fa-list-ul"></i>
        </button>
      </cm-dropdown-trigger>
      <mat-radio-group class="cm-dropdown-radio-list">
        <mat-radio-button *ngFor="let item of availableMetricsDetails" (change)="onChange($event)"
             class="cm-dropdown-select-item" [value]="item.key" [checked]="selectedMetric === item.key">
          {{item.label}}
        </mat-radio-button>
      </mat-radio-group>
    </cm-dropdown>
  `,
  styles: [`
      .cm-dropdown-radio-list {
          margin-bottom: -.5rem;
          display: block;
      }
  `]
})
export class ReportMetricSingleSelectDropdownComponent {

  @ViewChild('dropdown', { static: true }) dropdown: CmDropdownComponent;

  @Input()
  showLabel = false;

  @Input()
  availableMetricsDetails: ReportMetricDetails[];

  @Input()
  selectedMetric: ReportMetric;

  @Output()
  selectionChange = new EventEmitter<ReportMetric>();

  opened = false;

  constructor() {
  }

  onChange(event) {
    this.selectionChange.emit(event.value);
    this.dropdown.close();
  }

  toggle(open) {
    this.opened = open;
  }
}
